/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_TitleInputs */

const en_users_title = /** @type {(inputs: Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User management`)
};

const pt_br2_users_title = /** @type {(inputs: Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de usuários`)
};

/**
* | output |
* | --- |
* | "User management" |
*
* @param {Users_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_title = /** @type {((inputs?: Users_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_title(inputs)
	return pt_br2_users_title(inputs)
});